import { useState } from "react";
import { Checkbox, Divider, Modal, Collapse } from "antd";
import style from "./Style.module.css";
import "./style.css";
import { Button } from "antd";
import emergencyIcon from "../../asset/emergency.svg";
import dangerWarning from "../../asset/DangerWarning.png";
import TriagleWarning from "../../asset/triagleWarning.svg";

const { Panel } = Collapse;

const TermAndConditionSellerModal = (props) => {
  const [accept, setAccept] = useState(false);

  return (
    <Modal
      width={600}
      open={props.open}
      onOk={props.onOk}
      onCancel={props.onCancel}
      wrapClassName={"termAndConditionSellerModal"}
      footer={null}
      afterClose={() => {
        setAccept(false);
      }}
    >
      <img
        src={TriagleWarning}
        alt="triagleWarning"
        className="triagleWarning"
      />
      <div className="termAndConditionSellerBody">
        <img src={dangerWarning} alt="dangerWarningIcon" />
        <div className="penelty">
          <p>
            1.เนื้อหาในชีทสรุปเป็นเนื้อหาที่ข้าพเจ้าจัดทำขึ้นเอง
            ไม่มีการคัดลอกผลงานของผู้อื่น <br />
            2.ข้อมูลที่ใช้มีแหล่งอ้างอิงชัดเจน และไม่มีการละเมิดลิขสิทธิ์ <br />
            3.ไม่มีการนำข้อสอบหรือเฉลยข้อสอบมาเผยแพร่ในชีทสรุปดังกล่าว
          </p>
          <Divider />

          <Collapse expandIconPosition="end">
            <Panel
              header={
                <div className="grid-penalty-detail">
                  <img src={emergencyIcon} alt="emergencyIcon" />{" "}
                  <h4 style={{ margin: 0 }}>
                    บทลงโทษกรณีฝ่าฝืนข้อตกลงและเงื่อนไขการลงขายชีทสรุป
                  </h4>
                </div>
              }
              key="1"
            >
              <div className="grid-penalty-detail">
                <div />
                <p>
                  1. ระบบสงวนสิทธิ์ในการตรวจสอบชีทสรุปของผู้ขายทุกกรณี
                  หากพบว่าผิดเงื่อนไขใดข้อหนึ่ง
                  อาจมีบทลงโทษโดยไม่ต้องแจ้งล่วงหน้า <br />
                  2. บทลงโทษในกรณีที่ฝ่าฝืน การลบชีทสรุปออกจากระบบทันที
                  <ul>
                    <li>
                      การระงับบัญชีผู้ขายชั่วคราวหรือถาวร การขึ้นบัญชีดำ
                      (Blacklist)
                    </li>
                    <li>การดำเนินคดีตามกฎหมาย</li>
                    <li>หากพบการละเมิดลิขสิทธิ์หรือสิทธิในทรัพย์สินทางปัญญา</li>
                  </ul>
                </p>
              </div>
            </Panel>
          </Collapse>
        </div>
        <div className="penelty">
          <Checkbox
            onChange={(e) => setAccept(e.target.checked)}
            checked={accept}
          >
            ข้าพเจ้า <span style={{ color: "#F51919" }}>(ชื่อผู้ใช้งาน)</span>{" "}
            ขอยืนยันว่าได้อ่าน เข้าใจ และยอมรับข้อตกลงและเงื่อนไขทั้งหมด
            ตามข้อตกลงข้างต้นโดยไม่มีข้อโต้แย้งใด ๆ ทั้งสิ้น
          </Checkbox>
        </div>

        <p className={style.lightGreySmText}>
          moresheet เป็นเพียงผู้เผยแพร่ผลการของนักเขียนเท่านั้น
        </p>

        <div className="btn-group">
          <Button
            type="text"
            shape="round"
            className={"cancelBtn"}
            size="large"
            onClick={props.onCancel}
          >
            ยกเลิก
          </Button>
          <Button
            shape="round"
            className={"acceptBtn"}
            size="large"
            disabled={!accept || props.loading}
            loading={props.loading}
            onClick={props.onOk}
          >
            ยืนยัน
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TermAndConditionSellerModal;
